import { colors } from './index'
import configureStore from '../configureStore'
import convertStyleWithMultiplier from './styleHelper'

const buttonStyles = {
  buttonText: {
    fontSize: 14,
    textTransform: 'uppercase',
  },
  deselectedTroubleshootingYesNoFont: {
    fontSize: 14,
    color: colors.bscBlue,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  selectedTroubleshootingYesNoFont: {
    fontSize: 14,
    color: colors.white,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  deselectedTroubleShootingYesNoButtons: {
    borderWidth: 1,
    borderColor: colors.raven_grey50,
    borderRadius: 4,
    backgroundColor: colors.white,
  },
  selectedTroubleShootingYesNoButtons: {
    borderWidth: 1,
    borderColor: colors.bscBlue,
    backgroundColor: colors.bscBlue,
    borderRadius: 4,
  },
  noticeDetailButtons: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
    minHeight: 44,
    // width: 120,
    alignSelf: 'center',
  },
  faqHelpfulButton: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
    width: 120,
    alignSelf: 'center',
    borderWidth: 1,
    borderColor: colors.raven_grey70,
    borderRadius: 4,
  },
  troubleShootingYesNoButtons: {
    marginLeft: 15,
    marginRight: 15,
    minHeight: 44,
    minWidth: 95,
    paddingHorizontal: 5,
    justifyContent: 'center',
    alignContent: 'center',
  },
  saveButton: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
  },
  deleteMyDataButton: {
    marginBottom: 15,
  },
}

const Sheet = () => {
  const { storedData } = configureStore.getState()
  const { fontMultiplier } = storedData
  return convertStyleWithMultiplier(fontMultiplier || 1, buttonStyles)
}

export default Sheet()
